// extracted by mini-css-extract-plugin
export default {"numberInputContainer":"uhLdEr"};